import React, { useState, useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import axiosInstance from "../helpers/axiosInstance";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import { FaCogs } from 'react-icons/fa';

const AddDevice = () => {
    const [metadataFields, setMetadataFields] = useState([]);
    const [deviceName, setDeviceName] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [locationOptions, setLocationOptions] = useState([]);
    const navigate = useNavigate();
    const deviceMetadataConfig = useMemo(() => ({
        "Ultrasonic Sensor": [
            { key: "devEui", placeholder: "A1B2C3D4E5F67890", readOnly: true },
        ],
        "Display": [
            { key: "AccessUrl", placeholder: "http://192.168.1.100", readOnly: true },
            { key: "Username", placeholder: "Enter Username", readOnly: true },
            { key: "Password", placeholder: "Enter Password", readOnly: true },
        ],
        "ALPR": [
            { key: "sharpName", placeholder: "Enter sharp Name ", readOnly: true },
            { key: "Camera Name", placeholder: "Front Cam 01", readOnly: true },
        ],
        "RFID": [],
        "Boom Barrier": [
            { key: "Api url", placeholder: "http://192.168.1.100.php", readOnly: true },
        ],
        "Gateway": [],
    }), []);



    useEffect(() => {
        // Update locat
        // ion options based on selectedType
        console.log("Selected Type:", selectedType);
        setSelectedLocation(null); // Reset selected location when type changes
        setLocationOptions([]); // Reset location options when type changes
        if (selectedType === "Ultrasonic Sensor") {
            axiosInstance.get("/api/bays/active-empty-bay")
                .then((response) => {
                    const baysArray = response.data.data.bays;

                    const locations = baysArray.map((bay) => ({
                        value: bay.id,
                        label: `${bay.number} (${bay.shop.shop_name})`
                    }));

                    setLocationOptions(locations);
                })
                .catch((error) => Swal.fire("Error fetching bays:", 'error'));
        } else if (selectedType === "ALPR" || selectedType === "RFID" || selectedType === "Handheld" || selectedType === "Display" || selectedType === "Boom Barrier") {
            console.log("Selected type is not Ultrasonic Sensor. No location options available.");
            setLocationOptions([
                { value: "entry", label: "Entry" },
                { value: "exit", label: "Exit" },
                { value: "parking", label: "Parking" },
            ]);
            axiosInstance.get(`/api/plant/locationsWithoutDevices/${selectedType}`)
                .then((response) => {
                    const locatioData = response.data.data;
                    console.log("Location Data:", locatioData);

                    const locations = locatioData.map((location) => ({
                        value: location.id,
                        label: `${location.location_name} (${location.module.module_name})`
                    }));

                    setLocationOptions(locations);
                })
                .catch((error) => Swal.fire('Error', 'Error fetching locations', 'error'));

        }

        // ✅ Dynamically update metadata fields based on selected device type
        const defaultMetadata = deviceMetadataConfig[selectedType] || [];

        const resetMetadataFields = defaultMetadata.map(({ key }) => ({
            key,
            value: "",
        }));

        setMetadataFields(resetMetadataFields);
    }, [selectedType, deviceMetadataConfig]);




    const handleAddField = () => {
        setMetadataFields([...metadataFields, { key: "", value: "" }]);
    };

    const handleRemoveField = (index) => {
        const updatedFields = metadataFields.filter((_, i) => i !== index);
        setMetadataFields(updatedFields);
    };

    const handleSaveDevice = () => {
        if (!deviceName) {
            Swal.fire("Error", "Device name is required.", "error");
            return;
        }

        if (!selectedType) {
            Swal.fire("Error", "Device type is required.", "error");
            return;
        }

        if (!selectedLocation || !selectedLocation.label) {
            Swal.fire("Error", "Installation location is required.", "error");
            return;
        }

        const formattedMetadata = metadataFields
            .map(field => ({
                key_name: field.key.trim(),
                value_name: field.value.trim()
            }))
            .filter(field => field.key_name && field.value_name);

        if (formattedMetadata.length === 0) {
            Swal.fire("Error", "At least one metadata key-value pair is required.", "error");
            return;
        }

        const token = localStorage.getItem("authToken");
        let installedBy = null;

        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                installedBy = decodedToken.userId || null;
            } catch (error) {
                console.error("Error decoding token:", error);
            }
        }

        const devEuiValue = formattedMetadata.find(field => field.key_name === "devEui")?.value_name || null;

        const installationLocation = {
            location_type: selectedLocation.label,
            installed_by: installedBy,
        };
        if (selectedType === "Ultrasonic Sensor") {
            installationLocation.bay_id = selectedLocation.value;
            installationLocation.accessId = devEuiValue;
        }
        else {
            installationLocation.location_id = selectedLocation.value; // Set location_id for other types
        }

        const payload = {
            name: deviceName,
            type: selectedType,
            metadata: formattedMetadata,
            installationLocation
        };

        axiosInstance.post("/api/device/devices", payload)
            .then((response) => {
                console.log("API Response:", response.data);
                if (response.data.success) {
                    Swal.fire({
                        title: "Success",
                        text: response.data.message || "Device added successfully!",
                        icon: "success",
                    }).then(() => {
                        navigate("/device");
                    });
                } else {
                    Swal.fire("Error", response.data.message || "Failed to add device.", "error");
                }
            })
            .catch((error) => {
                console.error("Error adding device:", error);
                Swal.fire("Error", error.response?.data?.message || "Something went wrong. Please try again.", "error");
            });
    };

    const handleResetForm = () => {
        setDeviceName("");
        setSelectedType("");
        setMetadataFields([]);
        setSelectedLocation(null);
    };



    return (
        <div className="d-flex  align-items-center justify-content-center w-100 mt-4">
            <div className="container " style={{ height: "80vh", overflow: "hidden" }}>
                <div className="row shadow bg-white h-100">
                    <div className="col-md-3 d-flex flex-column align-items-center justify-content-center text-white text-center p-3"
                        style={{
                            background: "#8F8F8F",
                            height: "100%"
                        }}>
                        <FaCogs size={50} className="mb-3" />
                        <h3 className="fw-bold">Device Configuration</h3>
                        <p className="mt-2">Add and configure your new device</p>
                    </div>

                    <div className="col-md-1 d-flex align-items-center justify-content-center">
                        <div style={{ width: "2px", height: "90%", borderRight: "2px dotted #D8D8D8" }}></div>
                    </div>

                    <div className="col-md-8 pt-3 " style={{ overflowY: "auto", maxHeight: "70vh" }}>
                        <div className="row mb-1">

                            <div className="col-md-6 mb-2">
                                <label className="form-label fw-bold">
                                    Type <span style={{ color: "red" }}>*</span>
                                </label>
                                <select
                                    className="form-select"
                                    style={{ height: "45px", width: "90%" }}
                                    value={selectedType}
                                    onChange={(e) => setSelectedType(e.target.value)}
                                >
                                    <option value="" disabled>Select Type</option>
                                    <option value="Ultrasonic Sensor">Ultrasonic Sensor</option>
                                    <option value="ALPR">ALPR</option>
                                    <option value="RFID">RFID</option>
                                    <option value="Display">Display</option>
                                    <option value="Boom Barrier">Boom Barrier Controller</option>
                                    <option value="Gateway">Gateway</option>
                                </select>
                            </div>

                            <div className="col-md-6 mb-2">
                                <label className="form-label fw-bold">
                                    Name <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Device Name"
                                    value={deviceName}
                                    onChange={(e) => setDeviceName(e.target.value)}
                                    required
                                    style={{ height: "45px", width: "90%" }}
                                />
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="form-label fw-bold">Metadata Information <span style={{ color: "red" }}>*</span></label>

                            {(deviceMetadataConfig[selectedType] || []).map((fieldConfig, index) => (
                                <div className="mb-3 d-flex align-items-center gap-2" key={index}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={fieldConfig.key}
                                        value={fieldConfig.key}
                                        readOnly={fieldConfig.readOnly}
                                        style={{
                                            height: "45px",
                                            width: "28%",
                                            backgroundColor: fieldConfig.readOnly ? "#ddddddff" : "white",
                                            border: "1px solid #b9b9b9ff",
                                            color: "#333",
                                            fontWeight: "500",
                                        }}
                                    />

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={fieldConfig.placeholder}
                                        style={{
                                            height: "45px",
                                            width: "28%",
                                            backgroundColor: "#fafafa",
                                            border: "1px solid #e0e0e0",
                                            color: metadataFields[index]?.value ? "#000" : "#bfbfbf", // black if typed, light gray otherwise
                                            fontWeight: "400",
                                            fontSize: "16px",
                                        }}
                                        value={metadataFields[index]?.value || ""}
                                        onChange={(e) => {
                                            const updatedFields = [...metadataFields];
                                            updatedFields[index].value = e.target.value;
                                            setMetadataFields(updatedFields);
                                        }}
                                    />
                                </div>
                            ))}

                            {/* Additional dynamic fields if needed */}
                            {metadataFields.slice(deviceMetadataConfig[selectedType]?.length || 0).map((field, index) => {
                                const actualIndex = index + (deviceMetadataConfig[selectedType]?.length || 0);
                                return (
                                    <div className="mb-3 d-flex align-items-center gap-2" key={actualIndex}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Key"
                                            value={field.key}
                                            onChange={(e) => {
                                                const updatedFields = [...metadataFields];
                                                updatedFields[actualIndex].key = e.target.value;
                                                setMetadataFields(updatedFields);
                                            }}
                                            style={{ height: "45px", width: "28%" }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Value"
                                            value={field.value}
                                            onChange={(e) => {
                                                const updatedFields = [...metadataFields];
                                                updatedFields[actualIndex].value = e.target.value;
                                                setMetadataFields(updatedFields);
                                            }}
                                            style={{ height: "45px", width: "28%" }}
                                        />
                                        <button
                                            className="btn btn-outline-secondary rounded-circle p-0 d-flex align-items-center justify-content-center"
                                            style={{ width: "20px", height: "20px", fontSize: "20px" }}
                                            type="button"
                                            onClick={() => handleRemoveField(actualIndex)}
                                        >
                                            -
                                        </button>
                                    </div>
                                );
                            })}

                            <button
                                className="btn btn-outline-secondary rounded-circle p-0 d-flex align-items-center justify-content-center mt-1"
                                style={{ width: "20px", height: "20px", fontSize: "20px" }}
                                type="button"
                                onClick={handleAddField}
                            >
                                +
                            </button>
                        </div>



                        <div className="mb-5">
                            <label className="form-label fw-bold">Installation Location</label>
                            <Select
                                options={locationOptions}
                                value={selectedLocation}
                                onChange={(selected) => setSelectedLocation(selected)}
                                placeholder="Select Installation Location"
                                className="w-50"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#007bff" : "white",
                                        color: state.isFocused ? "white" : "black",
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: "45px",
                                        minHeight: "45px",
                                    }),
                                }}
                            />
                        </div>

                        <div className="d-flex justify-content-between">
                            <NavLink
                                to="/device"
                                className="btn fw-bold p-2 text-decoration-none text-black"
                                style={{ backgroundColor: "#D8D8D8", width: "100px", display: "inline-block", textAlign: "center" }}
                            >
                                Back
                            </NavLink>

                            <div>
                                <button
                                    className="btn fw-bold p-2 me-3"
                                    style={{ backgroundColor: "#BFBFBF", width: "100px" }}
                                    type="button"
                                    onClick={handleResetForm}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn fw-bold p-2 text-white"
                                    style={{ backgroundColor: "#0A4595", width: "150px" }}
                                    onClick={handleSaveDevice}
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddDevice;
